
import FieldsMapping from '@/qunit/fields_mapping';

export default class BP {
  constructor(data,lang,build_values) {
    if (data instanceof BP) {
      this.raw = {...data.raw};
      this.lang = data.lang;
      this.build_values = data.build_values || {};
    } else {
      this.raw = {...data};
      this.lang = lang || "es";
      this.build_values = build_values || {};
    }
    this.parse_bp();
  }

  change_lang(lang) {
    this.lang = lang || "es";
    this.parse_bp();
  }

  parse_bp() {
    //this.parse_json();
    this.parse_transitions();
    this.parse_inlines();
  }

  parse_json() {
    // Map all keys to this
    for (const [key, value] of Object.entries(this.raw)){
      this[key] = value;
    }
  }

  parse_transitions() {
    if (this.raw.model) {
      const parsed_transitions = [];
      for (const transition of (this.raw.transitions || [])) {
        let trans_layout = JSON.parse(JSON.stringify(transition.layout || []))
        let transition_parsed = trans_layout.map(row => row.map(col => this.parse_transition_input(col)));
        parsed_transitions.push(transition_parsed);
      }
      this._parsed_transitions = parsed_transitions;
    }
  }

  parse_transition_input(field) {
    let input_model = (this.raw.model || {})[field.id];
    let input = {...field, type: (input_model || {}).type, disabled: true, readonly: false,
                required: false, placeholder: ((input_model || {}).name || [])[this.lang] || field.id};
    
    if((field.type == 'BPTagField' || field.type == 'Tag') && field.name) {// TAG
      input.label = field.name[this.lang]
      input.component = input_types[input.type] || input_types[field.type] || "TextInput";
    } else {// NO TAG (input or spacer)
      input.component = input_types[input.type] || "TextInput";

      // SPACER
      if (!input_model) {
        input.class = 'text';
        input.placeholder = '';
      }
    }
    return input;
  }

  // TODO: Need more things to make all inlines work correctly
  parse_inlines() {
    if (this.raw.model) {
      const parsed_inlines = [];
      for (const inline of (this.raw.inline_boxes || [])) {
        let transition_parsed = {...inline};
        if (transition_parsed.type == 'BPInlineBoxData') {
          transition_parsed = {...transition_parsed,'layout': (inline.content || []).map(row => ({...row,'rows': (row.rows).map(it => it.map(col => this.parse_inline_field(col)))}))};
        }
        parsed_inlines.push(transition_parsed);
      }
      this._parsed_inlines = parsed_inlines;
    }
    return  {}
  }

  parse_inline_field(field) {
    let input_model = (this.raw.model || {})[field.id];
    let input = {...field, type: (input_model || {}).type || "BPTextField", disabled: true, readonly: false,
                required: false, label: ((input_model || {}).name || {})[this.lang] || field.id};
    input.component = input_types[input.type] || input_types[field.type];
    if(!!input_model) {
      delete input.value;
    } else {
      delete input.label;
    }
    input = new (FieldsMapping.apitype2field(input.type))(input);
    return input;
  }

  new_model_property() {
    return this.build_values.model || {};
  }

  new_state_property() {
    return this.build_values.states || {};
  }

  new_role_property() {
    return this.build_values.roles || {};
  }

  new_transition_property() {
    return this.build_values.transitions || {};
  }

  new_inline_property() {
    return this.build_values.inlines || {};
  }

  new_data_inline_property() {
    return this.build_values.inlines.data || {};
  }

  new_filter_property() {
    return this.build_values.filters || {};
  }

  new_column_property() {
    return this.build_values.columns || {};
  }

  generate_data_inline_from(transtions_id) {
    const data_inline_field_pops = [['id','id'],['name','title'],['layout','rows']]
    const trans_data = {...this.build_values.transitions};
    const transitions = this.raw.transitions.filter(tran => (transtions_id || []).includes(tran.id))
    const res = transitions.map(it => Object.fromEntries(data_inline_field_pops.map(key => ([key[1],it[key[0]]]))))
    return res;
  }

  update(id,value) {
    return new BP({...this.raw,[id]: value},this.lang,this.build_values);
  }

  delete(id) {
    let new_bp = this.raw;
    if (!!new_bp[id]) {
      delete new_bp[id]
    }
    return new BP(new_bp,this.lang,this.build_values);
  }

  get_model_name(prop,lang) {
    const raw_prop = this.raw.model[prop];
    if (!!raw_prop) {
      const names = raw_prop.name;
      if (Object.hasOwn(names,lang)) {
        return names[lang];
      } else {
        console.warn("The language inserted is not valid, it is gonna take a default language");
        return names[this.lang];
      }
    } else {
      return null;
    }
  }

  toJSON() {
    return this.raw;
  }
 }



const input_types = {
  "BPTextField": "TextInput",
  "BPChoiceField": "Select",
  "BPDateField": "DateInput",
  "BPDateTimeField": "DateTimeInput",
  "BPTextareaField": "TextareaInput",
  "BPNumericField": "NumericInput",
  "BPFileField": "FileInput",
  "BPUserDependingProcessField": "ProcessDependingUserField",
  "BPDirectoryField": "DirectoryInput",
  "BPTagField": "Tag",
  "BPAutocompleteChoiceField": "AutocompleteSelect",
  "BPDynamicChoiceField": "DynamicSelectInput",
  "BPDynamicInputField": "DynamicInput",
  "BPTimeEventField": "TimeEvent",
  "BPComputedField": "ComputedInput",
  "BPStateField": "StateInput",
  //"": "CheckboxInput",
  "BPTreeviewChoiceField": "TreeviewSelect",
  "BPIndicatorMetricsField": "IndicatorMetricInput",
  "BPIndicatorTrackingField": "IndicatorTrackingInput",
  "BPRelationshipsField": "RelatedSelect",
  //"": "MetricEdit",
}